import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

export default function ActionButton(props) {
  const theme = useTheme();
  const { disableMargin = false, ...rest } = props;
  return (
    <Button
      type="button"
      onClick={rest.onClick}
      variant="contained"
      size={rest.size ? rest.size : 'medium'}
      disabled={rest.disabled}
      fullWidth={rest.fullWidth}
      style={{
        color: rest.disabled
          ? theme.palette.text.disabled
          : rest.grayVersion
            ? theme.palette.text.disabled
            : theme.palette.text.main,
        margin: disableMargin ? 0 : '10px',
        backgroundColor: rest.disabled
          ? theme.palette.disabled.main
          : rest.grayVersion
            ? theme.palette.secondary.other
            : rest.secondaryButton
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
      }}
    >
      {rest.label}
    </Button>
  );
}

ActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  grayVersion: PropTypes.bool,
  disableMargin: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};
